export const APP_READY = 'app/READY'

export const appReady = () => ({
  type: APP_READY,
})
